import React from 'react';
import { Heart, Leaf, Utensils, TrendingUp } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Heart,
      title: 'Quality Standards',
      description: 'Proudly holding a 5-star food hygiene rating for your peace of mind and safety.'
    },
    {
      icon: Leaf,
      title: 'Local Ingredients',
      description: 'We source fresh, quality ingredients from local suppliers for the best taste.'
    },
    {
      icon: Utensils,
      title: 'Homemade Quality',
      description: 'Every dish is prepared fresh with traditional recipes and modern techniques.'
    },
    {
      icon: TrendingUp,
      title: 'Flexible Packages',
      description: 'Customizable menus and services to fit your budget and event requirements.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'var(--text-base)' }}>
            About Marlowes Catering
          </h2>
          <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--text-subtle-light)' }}>
            A professional catering business serving Chadderton, Oldham, and Greater Manchester with fresh, homemade food.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://images.pexels.com/photos/35041664/pexels-photo-35041664.jpeg"
              alt="Large pot of curry for buffet catering"
              className="w-full h-[400px] object-cover"
            />
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl font-bold" style={{ color: 'var(--text-base)' }}>
              Our Story
            </h3>
            <p className="text-lg" style={{ color: 'var(--text-subtle-light)' }}>
              Marlowes Catering has been the go-to choice for event catering in the Greater Manchester area. From corporate events to matchday catering for local football teams like Chadderton FC and Mancunian Unity FC, we bring passion and quality to every occasion.
            </p>
            <p className="text-lg" style={{ color: 'var(--text-subtle-light)' }}>
              We pride ourselves on using locally-sourced, fresh ingredients to create homemade dishes that exceed expectations. With our 5-star food hygiene rating, you can trust that your event will be catered with the highest standards of food safety and quality.
            </p>
            <div className="pt-4">
              <a
                href="tel:01612228831"
                className="inline-block px-8 py-3 rounded-lg font-semibold text-white transition-all"
                style={{ backgroundColor: 'var(--accent-ui-accent)' }}
              >
                Call Us Today
              </a>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="text-center p-6 rounded-xl transition-all card-hover"
                style={{ backgroundColor: 'var(--color-accent-coconut)' }}
              >
                <div className="flex justify-center mb-4">
                  <div
                    className="w-16 h-16 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: 'white' }}
                  >
                    <Icon size={32} style={{ color: 'var(--accent-ui-accent)' }} />
                  </div>
                </div>
                <h4 className="text-xl font-bold mb-2" style={{ color: 'var(--text-base)' }}>
                  {feature.title}
                </h4>
                <p style={{ color: 'var(--text-subtle-light)' }}>
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;